import './inline-icons.scss'

import React, {FunctionComponent} from 'react'

import {ClassName} from 'util/campagne/style'
import {style as utilStyle} from '../util/style'

const styles = utilStyle('inline-icons')

export const AlertGreyIcon: FunctionComponent = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="22"
			height="22"
			viewBox="0 0 22 22"
		>
			<g transform="translate(1 1)">
				<circle
					cx="10"
					cy="10"
					r="10"
					transform="translate(0 0)"
					fill="none"
					stroke="#d5dde0"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					stroke-width="2"
				/>
				<path
					d="M.5,0V4"
					transform="translate(9.5 6)"
					fill="none"
					stroke="#d5dde0"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					stroke-width="2"
				/>
				<path
					d="M.5.5H.5"
					transform="translate(9.505 13.5)"
					fill="none"
					stroke="#d5dde0"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-miterlimit="10"
					stroke-width="2"
				/>
			</g>
		</svg>
	)
}
export const ArrowIcon: FunctionComponent<{className?: ClassName | string}> = ({
	...props
}) => (
	<svg
		width="7px"
		height="12px"
		viewBox="0 0 7 12"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		className={props.className}
		{...props}
	>
		<path
			d="M1.155 11.7941C0.945 11.7941 0.525 11.7941 0.315 11.584C-0.105 11.1639 -0.105 10.5336 0.315 10.1134L4.485 5.84454L0.315 1.78571C-0.105 1.36555 -0.105 0.735294 0.315 0.315126C0.735 -0.105042 1.365 -0.105042 1.785 0.315126L6.585 5.21429C7.005 5.63445 7.005 6.26471 6.585 6.68487L1.785 11.584C1.785 11.7941 1.365 11.7941 1.155 11.7941Z"
			id="Path"
			fill="#FFFFFF"
			stroke="none"
		/>
	</svg>
)

export const ButtonShareIcon: FunctionComponent = ({...props}) => {
	return (
		<svg
			width="23px"
			height="23px"
			viewBox="0 0 23 23"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M19.1667 15.3333C17.8058 15.3333 16.616 16.0509 15.9359 17.1227L7.406 12.8578C7.56777 12.4338 7.66667 11.9792 7.66667 11.5C7.66667 11.0208 7.56777 10.5662 7.406 10.1422L15.9352 5.87727C16.616 6.94907 17.8058 7.66667 19.1667 7.66667C21.2804 7.66667 23 5.94703 23 3.83333C23 1.71963 21.2804 0 19.1667 0C17.053 0 15.3333 1.71963 15.3333 3.83333C15.3333 4.31327 15.4322 4.7679 15.594 5.1911L7.06407 9.45607C6.38403 8.38427 5.19417 7.66667 3.83333 7.66667C1.71963 7.66667 0 9.3863 0 11.5C0 13.6137 1.71963 15.3333 3.83333 15.3333C5.19417 15.3333 6.38403 14.6157 7.06407 13.5439L15.5932 17.8089C15.4322 18.2321 15.3333 18.6867 15.3333 19.1667C15.3333 21.2804 17.053 23 19.1667 23C21.2804 23 23 21.2804 23 19.1667C23 17.053 21.2804 15.3333 19.1667 15.3333Z"
				id="Path"
				fill="#FFFFFF"
				stroke="none"
			/>
		</svg>
	)
}

export const ButtonEditIcon: FunctionComponent = ({...props}) => {
	return (
		<svg
			width="22px"
			height="22px"
			viewBox="0 0 22 22"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15 0.828492C15.7145 0.11396 16.756 -0.165096 17.732 0.0964407C18.7081 0.357977 19.4705 1.12037 19.732 2.09644C19.9936 3.07251 19.7145 4.11396 19 4.82849L5.5 18.3285L0 19.8285L1.5 14.3285L15 0.828492Z"
				transform="translate(1 1)"
				id="Path"
				fill="none"
				stroke="#747678"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	)
}

export const DownloadIcon: FunctionComponent<{id: string}> = ({
	id,
	...props
}) => (
	<svg
		width="19px"
		height="16px"
		viewBox="0 0 19 16"
		version="1.1"
		id={id}
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M18.5 0C18.224 0 18 0.224 18 0.5L18 2.5C18 3.327 17.327 4 16.5 4L2.5 4C1.673 4 1 3.327 1 2.5L1 0.5C1 0.224 0.776 0 0.5 0C0.224 0 -9.09557e-13 0.224 -9.09557e-13 0.5L-9.09557e-13 2.5C-9.09557e-13 3.879 1.122 5 2.5 5L16.5 5C17.878 5 19 3.879 19 2.5L19 0.5C19 0.224 18.776 0 18.5 0Z"
			transform="translate(0 11)"
			id="Path"
			fill="#61C250"
			stroke="none"
		/>
		<path
			d="M3.12486 11.829C3.12886 11.833 3.13386 11.834 3.13786 11.838C3.17286 11.875 3.21486 11.903 3.25986 11.928C3.27386 11.936 3.28586 11.949 3.30086 11.956C3.36186 11.984 3.42886 12 3.50086 12C3.57286 12 3.63986 11.984 3.70186 11.956C3.71686 11.949 3.72786 11.937 3.74286 11.928C3.78786 11.903 3.82986 11.875 3.86486 11.838C3.86886 11.834 3.87386 11.833 3.87786 11.829L6.87786 7.829C7.05986 7.621 7.03886 7.306 6.83086 7.124C6.62286 6.942 6.30686 6.962 6.12486 7.171L4.00086 10.169L4.00086 0.5C4.00086 0.224 3.77686 0 3.50086 0C3.22486 0 3.00086 0.224 3.00086 0.5L3.00086 10.169L0.87686 7.171C0.69386 6.962 0.37786 6.942 0.17086 7.124C-0.0371398 7.306 -0.0581398 7.621 0.12386 7.829L3.12486 11.829Z"
			transform="translate(5.999023 0)"
			id="Path"
			fill="#61C250"
			stroke="none"
		/>
	</svg>
)

export const ErrorIcon: FunctionComponent<{className: string}> = ({
	className,
	...props
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="15.6"
		height="15.6"
		viewBox="0 0 15.6 15.6"
		{...props}
	>
		<g id="alert-circle" transform="translate(1.3 1.3)">
			<g
				id="Oval"
				fill="none"
				stroke="#ff585f"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.3"
				class
			>
				<circle cx="6.5" cy="6.5" r="6.5" stroke="none" />
				<circle cx="6.5" cy="6.5" r="7.15" fill="none" />
			</g>
			<path
				id="Path"
				d="M.5,0V3"
				transform="translate(6 4)"
				fill="none"
				stroke="#ff585f"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.3"
			/>
			<path
				id="Path-2"
				data-name="Path"
				d="M.5.5H.5"
				transform="translate(6 9)"
				fill="none"
				stroke="#ff585f"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.3"
			/>
		</g>
	</svg>
)

export const LocationIcon: FunctionComponent = ({...props}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="23"
		viewBox="0 0 16 23"
	>
		<path
			d="M8,23a.381.381,0,0,1-.305-.154C7.381,22.425,0,12.478,0,8.117A8.068,8.068,0,0,1,8,0a8.068,8.068,0,0,1,8,8.117c0,4.331-7.381,14.307-7.695,14.729A.381.381,0,0,1,8,23ZM8,3.833a4.217,4.217,0,1,0,4.19,4.217A4.208,4.208,0,0,0,8,3.833Z"
			fill="#61c250"
		/>
	</svg>
)
export const SearchIcon: FunctionComponent = ({...props}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="21"
		viewBox="0 0 21 21"
		{...props}
	>
		<path
			d="M20.237,21a.883.883,0,0,1-.495-.223l-6.86-6.817a7.053,7.053,0,0,1-5.066,1.789,7.875,7.875,0,1,1,7.816-7.875,6.8,6.8,0,0,1-1.777,4.957l6.926,6.935c.139.141.311.507.162.658l-.068.071a4.359,4.359,0,0,1-.48.457A.262.262,0,0,1,20.237,21ZM7.816,1.875a6,6,0,1,0,6,6A6.007,6.007,0,0,0,7.816,1.875Z"
			fill="#61c250"
		/>
	</svg>
)

export const SuccessIcon: React.FC<{
	className: string | ClassName
	isChecked: boolean
}> = ({className, isChecked, ...props}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="21.95"
			height="16.225"
			viewBox="0 0 21.95 16.225"
			className={styles('successicon field-checker-icon').is({
				checked: isChecked
			})}
			{...props}
		>
			<path
				d="M0,7,5,12,17,0"
				fill="none"
				stroke="#61c250"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit="10"
				strokeWidth="4"
				pathLength="1"
			/>
		</svg>
	)
}

export const DropdownArrowIcon: React.FC<{className: string | ClassName}> = ({
	className
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="11.794"
		height="6.9"
		viewBox="0 0 11.794 6.9"
		className={className}
	>
		<g transform="translate(11.95 -0.945) rotate(90)">
			<path
				d="M1.155,11.794a1.262,1.262,0,0,1-.84-.21,1.016,1.016,0,0,1,0-1.471l4.17-4.269L.315,1.786a1.016,1.016,0,0,1,0-1.471,1.015,1.015,0,0,1,1.47,0l4.8,4.9a1.016,1.016,0,0,1,0,1.471l-4.8,4.9C1.785,11.794,1.365,11.794,1.155,11.794Z"
				transform="translate(0.945 0.155)"
				fill="#d5dde0"
			/>
		</g>
	</svg>
)

export const LinkIcon: FunctionComponent = ({}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="26.55"
		height="26.55"
		viewBox="0 0 26.55 26.55"
	>
		<g transform="translate(0.275 0.275)">
			<path
				d="M5.252,13A4.853,4.853,0,0,1,1.8,11.571L1.427,11.2a4.886,4.886,0,0,1,0-6.9L4.3,1.429a4.884,4.884,0,0,1,6.9,0l.372.372a4.886,4.886,0,0,1,0,6.9L8.7,11.571A4.849,4.849,0,0,1,5.252,13ZM7.769,1A3.833,3.833,0,0,0,5.042,2.132L2.127,5.056a3.883,3.883,0,0,0,0,5.469L2.5,10.9A3.861,3.861,0,0,0,5.232,12a3.858,3.858,0,0,0,2.726-1.1L10.873,7.98a3.879,3.879,0,0,0,0-5.468l-.378-.38A3.822,3.822,0,0,0,7.769,1Z"
				transform="translate(13 0)"
				fill="#61c250"
				stroke="#61c250"
				stroke-miterlimit="10"
				stroke-width="0.55"
			/>
			<path
				d="M5.252,13A4.853,4.853,0,0,1,1.8,11.571L1.427,11.2a4.886,4.886,0,0,1,0-6.9L4.3,1.429a4.884,4.884,0,0,1,6.9,0l.372.372a4.886,4.886,0,0,1,0,6.9L8.7,11.571A4.849,4.849,0,0,1,5.252,13ZM7.769,1A3.833,3.833,0,0,0,5.042,2.132L2.127,5.056a3.883,3.883,0,0,0,0,5.469L2.5,10.9A3.861,3.861,0,0,0,5.232,12a3.858,3.858,0,0,0,2.726-1.1L10.873,7.98a3.879,3.879,0,0,0,0-5.468l-.378-.38A3.822,3.822,0,0,0,7.769,1Z"
				transform="translate(0 13)"
				fill="#61c250"
				stroke="#61c250"
				stroke-miterlimit="10"
				stroke-width="0.55"
			/>
			<path
				d="M.555,11a.553.553,0,0,1-.39-.159.547.547,0,0,1,0-.778l9.891-9.9a.557.557,0,0,1,.784,0,.547.547,0,0,1,0,.778l-9.891,9.9A.556.556,0,0,1,.555,11Z"
				transform="translate(8 8)"
				fill="#61c250"
				stroke="#61c250"
				stroke-miterlimit="10"
				stroke-width="0.55"
			/>
		</g>
	</svg>
)

export const MailIcon: FunctionComponent<{className?: string | ClassName}> = ({
	...props
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="26.5"
		height="18.5"
		viewBox="0 0 26.5 18.5"
		className={props.className}
	>
		<title>Mail</title>
		<g transform="translate(0.25 0.25)">
			<path
				d="M24,18H2a1.838,1.838,0,0,1-2-2V2A1.838,1.838,0,0,1,2,0H24a1.838,1.838,0,0,1,2,2V16A1.838,1.838,0,0,1,24,18ZM2,1c-.748,0-1,.252-1,1V16c0,.748.252,1,1,1H24c.748,0,1-.252,1-1V2c0-.748-.252-1-1-1Z"
				fill="#61c250"
				stroke="#61c250"
				stroke-miterlimit="10"
				stroke-width="0.5"
			/>
			<path
				d="M12.117,9a2.63,2.63,0,0,1-1.6-.546L.224,1.031A.589.589,0,0,1,.1.236.527.527,0,0,1,.861.108l10.3,7.424a1.568,1.568,0,0,0,1.918,0L23.139.108A.527.527,0,0,1,23.9.236a.587.587,0,0,1-.122.794L13.713,8.454A2.624,2.624,0,0,1,12.117,9Z"
				transform="translate(1 1)"
				fill="#61c250"
				stroke="#61c250"
				stroke-miterlimit="10"
				stroke-width="0.5"
			/>
			<path
				d="M.548,9A.545.545,0,0,1,.1,8.773.553.553,0,0,1,.226,8l9.9-7.9A.547.547,0,0,1,10.9.227.553.553,0,0,1,10.774,1L.87,8.9A.554.554,0,0,1,.548,9Z"
				transform="translate(1 8)"
				fill="#61c250"
				stroke="#61c250"
				stroke-miterlimit="10"
				stroke-width="0.5"
			/>
			<path
				d="M10.453,9a.541.541,0,0,1-.32-.1L.225.993A.551.551,0,0,1,.1.227.543.543,0,0,1,.867.105l9.908,7.9a.551.551,0,0,1,.121.766A.545.545,0,0,1,10.453,9Z"
				transform="translate(14 8)"
				fill="#61c250"
				stroke="#61c250"
				stroke-miterlimit="10"
				stroke-width="0.5"
			/>
		</g>
	</svg>
)

export const MessengerIcon: FunctionComponent = ({}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
	>
		<title>Messenger</title>
		<defs>
			<linearGradient
				id="messenger"
				x1="0.5"
				x2="0.5"
				y2="1"
				gradientUnits="objectBoundingBox"
			>
				<stop offset="0" stop-color="#00b2ff" />
				<stop offset="1" stop-color="#006aff" />
			</linearGradient>
		</defs>
		<path
			d="M16,0C6.986,0,0,6.6,0,15.521A15.184,15.184,0,0,0,5.025,27a1.289,1.289,0,0,1,.431.911l.087,2.846a1.282,1.282,0,0,0,1.8,1.133l3.174-1.4a1.277,1.277,0,0,1,.853-.064A17.4,17.4,0,0,0,16,31.041c9.014,0,16-6.6,16-15.521S25.014,0,16,0Z"
			fill="url(#messenger) #00b2ff"
		/>
		<path
			d="M.122,8.879,4.71,1.751A2.375,2.375,0,0,1,8.1,1.139L11.747,3.82a.954.954,0,0,0,1.128,0L17.8.154a.735.735,0,0,1,1.075.966L14.293,8.245a2.375,2.375,0,0,1-3.388.612L7.256,6.177a.954.954,0,0,0-1.128,0L1.2,9.846A.735.735,0,0,1,.122,8.879Z"
			transform="translate(7 11)"
			fill="#fff"
		/>
	</svg>
)

export const FacebookIcon: FunctionComponent<{style?: React.CSSProperties}> = ({
	style
}) => (
	<svg width="30.998" height="30.999" viewBox="0 0 30.998 30.999" style={style}>
		<title>Facebook</title>
		<defs>
			<clipPath id="facebook">
				<path
					d="M0,0H31V30.81H0Z"
					transform="translate(0.002 0.001)"
					fill="none"
				/>
			</clipPath>
		</defs>
		<g transform="translate(-0.002 -0.001)">
			<path
				d="M0,0H31V30.81H0Z"
				transform="translate(0.002 0.001)"
				fill="none"
			/>
			<g clip-path="url(#facebook)">
				<path
					d="M31,15.5A15.5,15.5,0,1,0,13.078,30.812V19.98H9.143V15.5h3.936V12.085c0-3.885,2.314-6.03,5.855-6.03a23.836,23.836,0,0,1,3.47.3v3.814H20.448a2.24,2.24,0,0,0-2.526,2.421V15.5h4.3l-.687,4.48H17.922V30.812A15.5,15.5,0,0,0,31,15.5"
					fill="#1877f2"
				/>
			</g>
			<path
				d="M12.391,13.926l.687-4.48h-4.3V6.538a2.24,2.24,0,0,1,2.526-2.421H13.26V.3A23.836,23.836,0,0,0,9.79,0C6.25,0,3.936,2.146,3.936,6.03V9.445H0v4.48H3.936V24.757a15.669,15.669,0,0,0,4.844,0V13.926h3.612"
				transform="translate(9.143 6.055)"
				fill="#fff"
			/>
		</g>
	</svg>
)
export const BlueskyIcon: FunctionComponent<{
	style?: React.CSSProperties
	ariaLabel?: string
}> = ({ariaLabel, style}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="64"
		height="57"
		fill="none"
		viewBox="0 0 64 57"
		style={style}
		aria-label={ariaLabel}
	>
		<title>Bluesky</title>
		<path
			fill="#0085ff"
			d="M13.873 3.805C21.21 9.332 29.103 20.537 32 26.55v15.882c0-.338-.13.044-.41.867-1.512 4.456-7.418 21.847-20.923 7.944-7.111-7.32-3.819-14.64 9.125-16.85-7.405 1.264-15.73-.825-18.014-9.015C1.12 23.022 0 8.51 0 6.55 0-3.268 8.579-.182 13.873 3.805ZM50.127 3.805C42.79 9.332 34.897 20.537 32 26.55v15.882c0-.338.13.044.41.867 1.512 4.456 7.418 21.847 20.923 7.944 7.111-7.32 3.819-14.64-9.125-16.85 7.405 1.264 15.73-.825 18.014-9.015C62.88 23.022 64 8.51 64 6.55c0-9.818-8.578-6.732-13.873-2.745Z"
		/>
	</svg>
)

export const LinkedInIcon: FunctionComponent<{
	style?: React.CSSProperties
	ariaLabel?: string
}> = ({ariaLabel, style}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="30"
		height="30"
		viewBox="0 0 30 30"
		style={style}
		aria-label={ariaLabel}
	>
		<title>LinkedIn</title>
		<path
			d="M27 0H3a3 3 0 00-3 3v24a3 3 0 003 3h24a3 3 0 003-3V3a3 3 0 00-3-3zM9 25.5H4.5V12H9zm-2.25-16a2.7 2.7 0 112.7-2.7 2.69 2.69 0 01-2.7 2.65zm18.75 16H21v-7.95a2.25 2.25 0 10-4.5 0v8H12V12h4.5v1.8a4.85 4.85 0 013.75-2.1A5.31 5.31 0 0125.5 17z"
			fill="#0077b5"
		/>
	</svg>
)

export const YouTubeIcon: FunctionComponent<{
	style?: React.CSSProperties
	ariaLabel?: string
}> = ({ariaLabel, style}) => (
	<svg
		viewBox="0 0 42.85 30"
		width="42.85"
		height="30"
		style={style}
		aria-label={ariaLabel}
	>
		<title>YouTube</title>
		<path
			d="M42 4.69A5.36 5.36 0 0038.19.92C34.84 0 21.42 0 21.42 0S8 0 4.66.88A5.51 5.51 0 00.88 4.69C0 8.05 0 15 0 15s0 7 .88 10.31a5.37 5.37 0 003.78 3.77c3.39.92 16.76.92 16.76.92s13.42 0 16.77-.88A5.37 5.37 0 0042 25.34c.89-3.35.89-10.3.89-10.3S42.88 8.05 42 4.69zM17.15 21.42V8.58L28.31 15z"
			fill="#fb0007"
		/>
	</svg>
)

export const CalendarIcon: FunctionComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18.6"
		height="17.6"
		viewBox="0 0 18.6 17.6"
	>
		<g transform="translate(0.8 0.8)">
			<rect
				width="17"
				height="14.4"
				rx="1.6"
				transform="translate(0 1.6)"
				stroke-width="1.6"
				stroke="#61c250"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				fill="none"
			/>
			<path
				d="M.4,0V3.2"
				transform="translate(12.548)"
				fill="none"
				stroke="#61c250"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.6"
			/>
			<path
				d="M.4,0V3.2"
				transform="translate(3.643)"
				fill="none"
				stroke="#61c250"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.6"
			/>
			<path
				d="M0,.4H17"
				transform="translate(0 6)"
				fill="none"
				stroke="#61c250"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.6"
			/>
		</g>
	</svg>
)

export const CalendarGreyIcon: FunctionComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="23"
		height="23"
		viewBox="0 0 23 23"
	>
		<path
			d="M20,23H3a2.84,2.84,0,0,1-3-3V5A3.224,3.224,0,0,1,3,2H5V4A7.629,7.629,0,0,0,6,5a1.513,1.513,0,0,1,.024-.417A1.124,1.124,0,0,0,6,4V0a.185.185,0,0,0,.164.076A1.36,1.36,0,0,0,6.356.054,3.816,3.816,0,0,1,6.959,0a.294.294,0,0,0-.073.016c-.028.012-.032.026-.032.033s.018.027.041.027S6.96.069,7,0V2h8V4a4.958,4.958,0,0,0,1,1,1.318,1.318,0,0,1,.007-.466A1.285,1.285,0,0,0,16,4V0c.04.069.087.076.1.076s.041-.012.041-.027,0-.021-.032-.033A.3.3,0,0,0,16.01,0a3.8,3.8,0,0,1,.634.054,1.361,1.361,0,0,0,.192.022A.185.185,0,0,0,17,0V2h3a3.224,3.224,0,0,1,3,3V20A2.841,2.841,0,0,1,20,23ZM1,8V20.133A1.894,1.894,0,0,0,3,22H20a1.894,1.894,0,0,0,2-1.867V8Z"
			fill="#747678"
		/>
		<g
			transform="translate(4 11)"
			fill="#d8d8d8"
			stroke="#979797"
			stroke-miterlimit="10"
			stroke-width="1"
		>
			<rect width="2" height="2" stroke="none" />
			<rect x="0.5" y="0.5" width="1" height="1" fill="none" />
		</g>
		<g
			transform="translate(8 11)"
			fill="#d8d8d8"
			stroke="#979797"
			stroke-miterlimit="10"
			stroke-width="1"
			opacity="0.6"
		>
			<rect width="2" height="2" stroke="none" />
			<rect x="0.5" y="0.5" width="1" height="1" fill="none" />
		</g>
		<g
			transform="translate(12 11)"
			fill="#d8d8d8"
			stroke="#979797"
			stroke-miterlimit="10"
			stroke-width="1"
			opacity="0.3"
		>
			<rect width="2" height="2" stroke="none" />
			<rect x="0.5" y="0.5" width="1" height="1" fill="none" />
		</g>
	</svg>
)

export const ClockIcon: FunctionComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="22"
		viewBox="0 0 22 22"
	>
		<path
			d="M11,22A11,11,0,1,1,22,11,11.012,11.012,0,0,1,11,22ZM11,1A10,10,0,1,0,21,11,10.011,10.011,0,0,0,11,1Z"
			fill="#4c4d4c"
		/>
		<path
			d="M4.629,13a.367.367,0,0,1-.263-.112L.109,8.485A.394.394,0,0,1,0,8.213V.384A.378.378,0,0,1,.372,0,.378.378,0,0,1,.743.384V8.053l4.148,4.291a.394.394,0,0,1,0,.544A.367.367,0,0,1,4.629,13Z"
			transform="translate(11 3)"
			fill="#4c4d4c"
		/>
	</svg>
)

export const PersonIcon: FunctionComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18.97"
		height="21.965"
		viewBox="0 0 18.97 21.965"
	>
		<path
			d="M5.42,10.983A5.462,5.462,0,0,1,0,5.491,5.462,5.462,0,0,1,5.42,0,5.463,5.463,0,0,1,10.84,5.492,5.462,5.462,0,0,1,5.42,10.983Zm0-9.61a4.119,4.119,0,0,0,0,8.238,4.119,4.119,0,0,0,0-8.238Z"
			transform="translate(4.065 0)"
			fill="#61c250"
		/>
		<path
			d="M18.292,9.563H.678A.683.683,0,0,1,0,8.877V4.152A2.069,2.069,0,0,1,.933,2.411,15.965,15.965,0,0,1,9.487,0a15.945,15.945,0,0,1,8.549,2.411,2.068,2.068,0,0,1,.934,1.741V8.877A.683.683,0,0,1,18.292,9.563Zm-8.808-8.2A14.609,14.609,0,0,0,1.651,3.576a.677.677,0,0,0-.3.576V8.191H17.615V4.152a.679.679,0,0,0-.3-.577A14.615,14.615,0,0,0,9.485,1.368Z"
			transform="translate(0 12.402)"
			fill="#61c250"
		/>
	</svg>
)

export const LocationSmallIcon: FunctionComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="13"
		height="18"
		viewBox="0 0 13 18"
	>
		<path
			d="M6.5,18a.314.314,0,0,1-.247-.12C6,17.55,0,9.761,0,6.352A6.435,6.435,0,0,1,6.5,0,6.435,6.435,0,0,1,13,6.352c0,3.409-6,11.2-6.252,11.528A.312.312,0,0,1,6.5,18Zm0-15A3.358,3.358,0,0,0,3.1,6.3,3.358,3.358,0,0,0,6.5,9.6,3.358,3.358,0,0,0,9.9,6.3,3.358,3.358,0,0,0,6.5,3Z"
			fill="#61c250"
		/>
	</svg>
)

export const CalendarSmallIcon: FunctionComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="23"
		height="23"
		viewBox="0 0 23 23"
	>
		<path
			d="M20,23H3a2.84,2.84,0,0,1-3-3V5A3.224,3.224,0,0,1,3,2H5V4A7.629,7.629,0,0,0,6,5a1.513,1.513,0,0,1,.024-.417A1.124,1.124,0,0,0,6,4V0a.185.185,0,0,0,.164.076A1.36,1.36,0,0,0,6.356.054,3.816,3.816,0,0,1,6.959,0a.294.294,0,0,0-.073.016c-.028.012-.032.026-.032.033s.018.027.041.027S6.96.069,7,0V2h8V4a4.958,4.958,0,0,0,1,1,1.318,1.318,0,0,1,.007-.466A1.285,1.285,0,0,0,16,4V0c.04.069.087.076.1.076s.041-.012.041-.027,0-.021-.032-.033A.3.3,0,0,0,16.01,0a3.8,3.8,0,0,1,.634.054,1.361,1.361,0,0,0,.192.022A.185.185,0,0,0,17,0V2h3a3.224,3.224,0,0,1,3,3V20A2.841,2.841,0,0,1,20,23ZM1,8V20.133A1.894,1.894,0,0,0,3,22H20a1.894,1.894,0,0,0,2-1.867V8Z"
			fill="#61c250"
		/>
	</svg>
)

export const AlertGreenIcon: FunctionComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="22"
		viewBox="0 0 22 22"
	>
		<g transform="translate(1 1)">
			<circle
				cx="10"
				cy="10"
				r="10"
				fill="none"
				stroke="#61c250"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="2"
			/>
			<path
				d="M.5,0V4"
				transform="translate(9.5 6)"
				fill="none"
				stroke="#61c250"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="2"
			/>
			<path
				d="M.5.5H.5"
				transform="translate(9.505 13.5)"
				fill="none"
				stroke="#61c250"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="2"
			/>
		</g>
	</svg>
)

export const PhoneIcon: FunctionComponent = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="11.9"
		height="11.9"
		viewBox="0 0 11.9 11.9"
	>
		<path
			d="M11.007,7.933a6.486,6.486,0,0,1-2.182-.347.951.951,0,0,0-.892.2L6.545,8.826A7.593,7.593,0,0,1,3.074,5.355L4.115,3.967a.862.862,0,0,0,.2-.892A8.025,8.025,0,0,1,3.967.892.889.889,0,0,0,3.074,0H.892A.889.889,0,0,0,0,.892,11.046,11.046,0,0,0,11.007,11.9a.889.889,0,0,0,.892-.892V8.776A.88.88,0,0,0,11.007,7.933Z"
			fill="#61c250"
		/>
	</svg>
)

export const CrossIcon: FunctionComponent<{className: ClassName | string}> = ({
	className
}) => (
	<svg
		version="1.1"
		id="Capa_1"
		x="0px"
		y="0px"
		viewBox="0 0 348.333 348.334"
		className={className}
	>
		<g>
			<path
				d="M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85
		c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563
		c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85
		l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554
		L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z"
			/>
		</g>
	</svg>
)

export const HelpIcon: FunctionComponent<{
	class?: ClassName | string
}> = ({class: className}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16.5"
		height="16.5"
		viewBox="0 0 16.5 16.5"
		className={className}
	>
		<g transform="translate(0.75 0.75)">
			<path
				d="M7.5,0A7.5,7.5,0,0,1,15,7.5a7.635,7.635,0,0,1-2.931,5.948A7.256,7.256,0,0,1,7.5,15a7.5,7.5,0,0,1,0-15Z"
				fill="none"
				stroke="#61c250"
				stroke-linecap="round"
				stroke-width="1.5"
			/>
			<path
				d="M0,1.5a2.25,2.25,0,0,1,4.372.75c0,1.5-2.25,2.25-2.25,2.25"
				transform="translate(5.318 3.746)"
				fill="none"
				stroke="#61c250"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.5"
			/>
			<path
				d="M.371.375H.379"
				transform="translate(7.129 10.875)"
				fill="none"
				stroke="#61c250"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.5"
			/>
		</g>
	</svg>
)

export const PlayIcon: FunctionComponent = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="96"
			height="96"
			viewBox="0 0 96 96"
		>
			<defs>
				<filter
					id="a"
					x="0"
					y="0"
					width="96"
					height="96"
					filterUnits="userSpaceOnUse"
				>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="7.5" result="b" />
					<feFlood flood-opacity="0.4" />
					<feComposite operator="in" in2="b" />
					<feComposite in="SourceGraphic" />
				</filter>
			</defs>
			<g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#a)">
				<path
					d="M25.5,51A25.507,25.507,0,0,1,15.574,2,25.507,25.507,0,0,1,35.426,49,25.34,25.34,0,0,1,25.5,51ZM22,18V33l12-7.5Z"
					transform="translate(22.5 18.5)"
					fill="#fff"
				/>
			</g>
		</svg>
	)
}

export const InstagramIcon: FunctionComponent<{
	style?: React.CSSProperties
	ariaLabel?: string
}> = ({ariaLabel, style}) => (
	<svg
		width="30"
		height="30"
		viewBox="0 0 30 30"
		aria-label={ariaLabel}
		style={style}
	>
		<defs>
			<linearGradient
				id="instagram_svg__a"
				x1="2.52"
				y1="2.52"
				x2="27.48"
				y2="27.49"
				gradientTransform="matrix(1 0 0 -1 0 30)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stop-color="#ffd600" />
				<stop offset="0.5" stop-color="#ff0100" />
				<stop offset="1" stop-color="#d800b9" />
			</linearGradient>
			<linearGradient
				id="instagram_svg__b"
				x1="9.55"
				y1="9.56"
				x2="20.45"
				y2="20.45"
				gradientTransform="matrix(1 0 0 -1 0 30)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stop-color="#ff6400" />{' '}
				<stop offset="0.5" stop-color="#ff0100" />
				<stop offset="1" stop-color="#fd0056" />
			</linearGradient>
			<linearGradient
				id="instagram_svg__c"
				x1="21.73"
				y1="21.74"
				x2="24.28"
				y2="24.28"
				gradientTransform="matrix(1 0 0 -1 0 30)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stop-color="#f30072" />
				<stop offset="1" stop-color="#e50097" />
			</linearGradient>
		</defs>
		<path
			d="M29.91 8.82a11 11 0 00-.7-3.65 7.17 7.17 0 00-1.73-2.65A7.17 7.17 0 0024.83.79a11 11 0 00-3.65-.7C19.58 0 19.07 0 15 0s-4.58 0-6.18.09a11 11 0 00-3.65.7 7.17 7.17 0 00-2.65 1.73A7.17 7.17 0 00.79 5.17a11 11 0 00-.7 3.65C0 10.42 0 10.93 0 15s0 4.58.09 6.18a11 11 0 00.7 3.65 7.17 7.17 0 001.73 2.65 7.17 7.17 0 002.65 1.73 11 11 0 003.65.7c1.6.07 2.11.09 6.18.09s4.59 0 6.18-.09a11 11 0 003.65-.7 7.68 7.68 0 004.38-4.38 11 11 0 00.7-3.65c.09-1.6.09-2.11.09-6.18s0-4.58-.09-6.18zm-2.7 12.24a8.3 8.3 0 01-.52 2.79 4.94 4.94 0 01-2.84 2.84 8.3 8.3 0 01-2.79.52c-1.58.07-2 .09-6.06.09s-4.48 0-6.06-.09a8.3 8.3 0 01-2.79-.52 4.58 4.58 0 01-1.72-1.12 4.58 4.58 0 01-1.12-1.72 8.3 8.3 0 01-.52-2.79C2.72 19.48 2.7 19 2.7 15s0-4.48.09-6.06a8.3 8.3 0 01.52-2.79 4.58 4.58 0 011.12-1.72 4.58 4.58 0 011.72-1.12 8.3 8.3 0 012.79-.52C10.52 2.72 11 2.7 15 2.7c4 0 4.48 0 6.06.09a8.3 8.3 0 012.79.52 4.58 4.58 0 011.72 1.12 4.58 4.58 0 011.12 1.72 8.3 8.3 0 01.52 2.79c.07 1.58.09 2.05.09 6.06s-.02 4.48-.09 6.06z"
			fill="url(#instagram_svg__a)"
		/>
		<path
			d="M15 7.3a7.7 7.7 0 107.7 7.7A7.7 7.7 0 0015 7.3zM15 20a5 5 0 115-5 5 5 0 01-5 5z"
			fill="url(#instagram_svg__b)"
		/>
		<path
			d="M24.81 7A1.8 1.8 0 1123 5.19 1.8 1.8 0 0124.81 7z"
			fill="url(#instagram_svg__c)"
		/>
	</svg>
)
